import { useFormContext } from 'react-hook-form'
import { splitStringByLength } from 'src/utils/StringUtil'
import { InvoiceFormInputs } from '../InvoiceEditForm'

export const CompanyPart: React.FC<{ hasLogo: boolean }> = ({ hasLogo }) => {
  const { watch } = useFormContext<InvoiceFormInputs>()
  const company = watch('company')

  const companyName = splitStringByLength(company.name, 15)

  const company1 = [
    company.department_name,
    company.user_name,
    company.registration_number && company.registration_number !== ''
      ? `登録番号: ${company.registration_number} `
      : ''
  ]

  const company2 = [
    company.zip_code,
    ...splitStringByLength(company.address, 15)
  ]
  const company3 = [company.tel, company.email]
  return (
    <>
      {companyName.map((line, i) => (
        <text
          key={i}
          x={hasLogo ? 270 : 300}
          y={98 + i * 14}
          fill="#0D0D0D"
          fontSize={'10px'}
          fontWeight="bold"
        >
          {line}
        </text>
      ))}
      {[company1, company2, company3].map((part, i, arr) =>
        part
          .filter((v) => v && v !== '')
          .map((value, j) => (
            <text
              key={`${i}-${j}`}
              y={
                98 +
                companyName.length * 14 +
                6 * i +
                14 *
                  (arr
                    .slice(0, Math.max(i, 0))
                    .reduce((prev, curr) => prev + curr.length, 0) +
                    j)
              }
              x={hasLogo ? 270 : 300}
              fill="#0D0D0D"
              fontSize={'10px'}
            >
              {value}
            </text>
          ))
      )}
    </>
  )
}
